import React, { type ReactNode } from 'react';
import EmptyState from '@atlaskit/empty-state';
import { Box, xcss } from '@atlaskit/primitives';
import ImageComponent from '@atlassian/jira-illustrations/src/ui/adg4/jira/spots/error/components/exclamation-triangle-yellow/index.tsx';
import { getAkEmptyStateRenderImageFn } from '@atlassian/jira-illustrations/src/ui/helpers/ak-empty-state/index.tsx';
import { useIntl } from '@atlassian/jira-intl/src/index.tsx';
import { GlobalPageLoadExperience } from '@atlassian/ufo';
import messages from './messages.tsx';

export type ImageWrapperProps = {
	children: ReactNode;
};

const Error = () => {
	GlobalPageLoadExperience.failure({ force: true });
	const { formatMessage } = useIntl();

	return (
		<EmptyState
			header={formatMessage(messages.errorHeader)}
			description={formatMessage(messages.errorDescription)}
			renderImage={getAkEmptyStateRenderImageFn(() => (
				<ImageWrapper>
					<ImageComponent alt="error-image" fill />
				</ImageWrapper>
			))}
		/>
	);
};

const ImageWrapper: React.FC<ImageWrapperProps> = ({ children }) => (
	<Box xcss={wrapperStyles}>{children}</Box>
);

const wrapperStyles = xcss({
	height: '160px',
	position: 'relative',
});

export default Error;
